import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'assembly/definition';

const assemblyDefinitionService = {
  getItems: (data, signal) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
      signal,
    });
  },

  getItemById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  searchItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/search`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default assemblyDefinitionService;
